import * as React from 'react';
import {
  Card,
  CardMedia,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { DEFAULT_IMG } from '../../../../shared/config/constants';

const FeaturesCard = function ({
  image,
  label,
  reduceSize,
}) {
  return (
    <Card
      sx={{ borderRadius: '10px', width: 'clamp(270px, 21vw, 325px)', height: '440px', m: { xs: '10px', md: '5px' }, p: '10px', background: '#FFF' }}
    >
      <CardMedia
        component="img"
        width="auto"
        height="300px"
        image={image || DEFAULT_IMG}
        sx={{
          objectFit: reduceSize ? 'contain' : 'cover',
          padding: reduceSize ? '10px' : 0,
        }}
      />
      <Typography variant='h4' flexWrap={'wrap'} sx={{ height: '100px', textAlign: 'center', mt: 2 }}>{label}</Typography>
    </Card>
  );
};

FeaturesCard.propTypes = {
  image: PropTypes.string,
  label: PropTypes.string,
  reduceSize: PropTypes.bool,
};

export default FeaturesCard;
